import { articleActions, articleReducer } from "./article";
import { authActions, authReducer } from "./auth";
import { circleActions, circleReducer } from "./circles";
import { collaboratorActions, collaboratorReducer } from "./collaborator";
import { commentsActions, commentsReducer } from "./comments";
import { commonActions, commonReducer } from "./common";
import { connectionsActions, connectionsReducer } from "./connections";
import { infoActions, infoReducer } from "./info";
import { meActions, meReducer } from "./me";
import { newsfeedActions, newsfeedReducer } from "./newsfeed";
import { nlpActions, nlpReducer } from "./nlp";
import { onboardingActions, onboardingReducer } from "./onboarding";
import { pollsActions, pollsReducer } from "./polls";
import { postAnalysisActions, postAnalysisReducer } from "./postAnalysis";
import { postAudioActions, postAudioReducer } from "./postAudio";
import { postGIFActions, postGIFReducer } from "./postGIF";
import { postsActions, postsReducer } from "./posts";
import { postVideoActions, postVideoReducer } from "./postVideo";
import { reactionsActions, reactionsReducer } from "./reactions";
import { reportPostActions, reportPostReducer } from "./reportPost";
import { savedItemsActions, savedItemsReducer } from "./savedItems";

export type ReduxKeys = keyof typeof actions;

export const actions = {
  auth: authActions,
  connections: connectionsActions,
  info: infoActions,
  me: meActions,
  newsfeed: newsfeedActions,
  nlp: nlpActions,
  onboarding: onboardingActions,
  polls: pollsActions,
  posts: postsActions,
  reactions: reactionsActions,
  reportPost: reportPostActions,
  savedItems: savedItemsActions,
  comments: commentsActions,
  circle: circleActions,
  postAnalysis: postAnalysisActions,
  postAudio: postAudioActions,
  postVideo: postVideoActions,
  postGIF: postGIFActions,
  collaborator: collaboratorActions,
  common: commonActions,
  article: articleActions,
};

export const reducer = {
  auth: authReducer,
  connections: connectionsReducer,
  info: infoReducer,
  me: meReducer,
  newsfeed: newsfeedReducer,
  nlp: nlpReducer,
  onboarding: onboardingReducer,
  polls: pollsReducer,
  posts: postsReducer,
  reactions: reactionsReducer,
  reportPost: reportPostReducer,
  savedItems: savedItemsReducer,
  comments: commentsReducer,
  circle: circleReducer,
  postAnalysis: postAnalysisReducer,
  postAudio: postAudioReducer,
  postVideo: postVideoReducer,
  postGIF: postGIFReducer,
  collaborator: collaboratorReducer,
  common: commonReducer,
  article: articleReducer,
};
